import React from "react";

import cx from "classnames";

import { Spacer } from "../Grid";

import styles from "./Select.scss";

export function SelectOption<Values extends string | number = string>({
  option,
  selected,
  compact,
  disabledLabel = "",
  highlighted,
  onSelect,
}: {
  option: {
    label?: string;
    value: Values;
    disabled?: boolean;
    labelDecorator?: React.ReactNode;
  };
  selected?: boolean;
  compact?: boolean;
  disabledLabel?: string;
  highlighted?: boolean;
  onSelect?: (option: {
    value: Values;
    disabled?: boolean;
    labelDecorator?: React.ReactNode;
  }) => void;
}) {
  const optionClassName = cx(styles["select-option"], {
    [styles.compact]: compact,
    [styles.disabled]: option.disabled,
    [styles.highlighted]: highlighted,
    [styles["label-decorator"]]: option.labelDecorator,
  });

  return (
    <button
      ref={(ref) => {
        // When the ref is mounted, this callback is invoked so we can focus
        // the button. This is for accessibility.
        if (ref && highlighted) {
          ref.focus();
        }
      }}
      className={optionClassName}
      onClick={(e) => {
        e.preventDefault();
        if (!option.disabled) {
          onSelect?.(option);
        }
      }}
      role="option"
      tabIndex={-1}
      aria-selected={selected}
    >
      {option.labelDecorator && option.labelDecorator}
      {option.labelDecorator && (
        <Spacer size="small" orientation="horizontal" />
      )}
      {option.label || option.value}
      {option.disabled && (
        <span className="screen-reader-only">{disabledLabel}</span>
      )}
    </button>
  );
}
